import { addTransformUtils } from '@/utils/formHelpers';

export default function parseUrl(searchOptions, router) {
  const formattedQueryGroup = {};
  const { query: queryGroup, asPath: url } = router;

  const hasQueryInitializer = url.indexOf('?') > -1;

  if (!hasQueryInitializer) {
    return {};
  }

  const queryKeys = Object.keys(queryGroup);

  queryKeys.forEach(k => {
    const _k = k.toLowerCase();
    const value = Array.isArray(queryGroup[k]) ? queryGroup[k].join(',') : queryGroup[k];

    switch (_k) {
      case 'states':
        formattedQueryGroup.states = value.split(',');
        break;
      case 'charts':
        formattedQueryGroup.charts = value.split(',').map(id => Number(id));
        break;
      case 'categories':
        formattedQueryGroup.categories = value.split(',').map(id => Number(id));
        break;
      case 'searchtext':
        formattedQueryGroup.searchText = value;
        break;
      case 'datestart':
        formattedQueryGroup.dateStart = value;
        break;
      case 'dateend':
        formattedQueryGroup.dateEnd = value;
        break;
      default:
        break;
    }
  });

  const copyFieldOptions = addTransformUtils(formattedQueryGroup, searchOptions);

  queryKeys.forEach(k => {
    const _k = k.toLowerCase();

    switch (_k) {
      case 'states':
        formattedQueryGroup.states = copyFieldOptions.getFullComplex('states', 'stateCode');
        break;
      case 'charts':
        formattedQueryGroup.charts = copyFieldOptions.getFullComplex('charts', 'chartId');
        break;
      case 'categories':
        formattedQueryGroup.categories = copyFieldOptions.getFullComplex(
          'categories',
          'categoryId'
        );
        break;
      default:
        break;
    }
  });

  return formattedQueryGroup;
}